// removed by extract-text-webpack-plugin
module.exports = {"nav":"src-ui-navbar----navbar-module---nav---3gyUy","menu":"src-ui-navbar----navbar-module---menu---3Wmuv","menu__links":"src-ui-navbar----navbar-module---menu__links---3hAmS","menu__link":"src-ui-navbar----navbar-module---menu__link---1xmRl","MenuToggle":"src-ui-navbar----navbar-module---MenuToggle---3y5Na","menu--collapsed":"src-ui-navbar----navbar-module---menu--collapsed---3A-IZ","menu--expanded":"src-ui-navbar----navbar-module---menu--expanded---3vunN"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/navbar/navbar.module.scss
// module id = 323
// module chunks = 114276838955818